<h2 mat-dialog-title>Notice</h2>
<mat-dialog-content class="mat-typography">
  <h3>Please complete your details before proceeding.</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button mat-button disableClose="false" cdkFocusInitial (click)="navigateBackProfiling()">Go back</button> -->
  <button mat-button [mat-dialog-close]="true" (click)="navigateBackProfiling()" cdkFocusInitial>Go back</button>
</mat-dialog-actions>
